import React from 'react';

const ServicesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/services',
      exact: true,
      component: React.lazy(() => import('./services_list'))
    }
  ]
};

const ServiceAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/service/add',
      component: React.lazy(() => import('./services_edit'))
    }
  ]
};

const ServicesManagerConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SERVICEMANAGER', 'ROLE_SERVICEMANAGER_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/services/associate',
      exact: true,
      component: React.lazy(() => import('./service_manager'))
    }
  ]
};

const ServiceEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/service/:id',
      component: React.lazy(() => import('./services_edit'))
    }
  ]
};

export {
  ServicesManagerConfig,
  ServicesConfig,
  ServiceEditConfig,
  ServiceAddConfig
};
